export const FILE_TYPE_OPTIONS = {
  retail: "Retail",
  retail_with_tips: "Retail with Tips",
  restaurant_with_tip_adjust: "Restaurant with Tip Adjust",
};

export const PACKAGE_OPTIONS = {
  e_commerce_cart_plus: "E-Commerce Cart Plus",
  web_hosting_professional: "Web Hosting Professional",
  web_hosting_premier: "Web Hosting Premier",
  web_pak_professional: "WebPak Professional",
  web_pak_premier: "WebPak Premier",
  no_equipment: "No Equipment",
  premier_150: "Premier 150",
  premier_250: "Premier 250",
  premier_500: "Premier 500",
  vl_basic: "VL Basic",
  vl_bundle: "VL Bundle",
  gold: "Gold",
  silver: "Silver",
  bronze: "Bronze",
};

export const CABLE_LENGTH_OPTIONS = {
  25: "25",
  50: "50",
  100: "100",
};

export const CONNECTIVITY_OPTIONS = {
  wifi: "WIFI",
  sim: "SIM",
  ip: "IP",
  vl_wireless: "VL WIRELESS",
};

export const EMS_BOOT_DEFAULT_DATA = {
  monthly_fee: false,
  monthly_fee_default: "25.00",
  per_transaction: false,
  per_transaction_default: "0.10",
  purchase_for: false,
  purchase_for_default: "230.00",
  rent_for: false,
  rent_for_default: "20.00",
  apply_tpp: false,
  apply_tpp_default: "yes",
  sass_fee: false,
  sass_fee_default: "230.00",
  lease_for: false,
  lease_for_default: "20.00",
  amount: false,
  amount_default: "25.00",
  factor_rate: false,
  factor_rate_default: "0.10",
  payback: false,
  payback_default: "0.10",
  sim_card: false,
  sim_card_monthly_default: "0.05",
  hardware: false,
  hardware_default: "",
  file_types: false,
  file_types_default: "",
  package: false,
  package_default: "",
  other_equipment: false,
  other_equipments_default: "",
  pin_debit: false,
  cable_length: false,
  cable_length_default: "",
  customer_facing: false,
  virtual_terminal: false,
  monthly_wireless: false,
  monthly_wireless_default: "0.10",
  text_sms_fee: false,
  text_sms_fee_default: "0.10",
  promotion_text: "",
  connectivity: false,
  connectivity_options: "",
  connectivity_default: "sim",
  monthly_cellular_txn: false,
  cellular_per_txn: false,
  monthly_cellular_txn_default: "25",
  cellular_per_txn_default: "0.10",
  add_on_equipment: false,
  add_on_equipment_options: "",
  equipment_for_nuvie: false,
  nuvie_equipment_name: "",
  pin_pad: false,
  pin_pad_name_default: "",
};
